
    <app-circle-btn delete (btnClicked)="btnEvent()" [frame]="frame">
      <app-delete-icon *ngIf="!frame"></app-delete-icon>
      <app-delete-frame-icon *ngIf="frame"></app-delete-frame-icon>
    </app-circle-btn>
  